import { request } from 'src/commons/utils/async-request';
import { readCsrfToken } from './read-csrf-token';

// FIT CSRF token, decoupled from the full navState payload.
const url = '/ccx/ajax/getCsrfToken';

// Throws when the token is absent so the failure is logged at fetch time,
// rather than silently proceeding to a POST that will fail CSRF anyway.
export default async (): Promise<string> => {
  const body = await request<string>({
    url,
    retries: 2,
    responseType: 'text',
  });
  const csrfToken = readCsrfToken(body);
  if (!csrfToken) {
    throw new Error('getCsrfToken: response missing csrfToken');
  }
  return csrfToken;
};
